import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useMutation } from 'react-query';
import { useForm } from 'react-hook-form';
import { Form, Input, Label, Button, Spinner, Card, FormGroup } from 'reactstrap';

import AuthLayout from 'layouts/AuthLayout';
import bootbox from 'components/Modals/Bootbox';
import { forgotPassword } from 'api/actions/auth'
import { fetcher } from 'api/client';
 
function RecoverForm() {

    const { t } = useTranslation();
    const history = useHistory();
    const { register, handleSubmit } = useForm();

    const { mutate: mutateRecover, isLoading } = useMutation((payload) => fetcher(forgotPassword(payload)), {
        onSuccess: (result, vars) => {
            bootbox.alert(t('login.password.recover', { replace: { email: vars.email } }));
        },
        onSettled: () => {
            history.push('/login');
        }
    });

    const doSubmit = (formValues, actions) => {
        mutateRecover(formValues)
    }

    const handleRemembered = () => {
        history.push('/login');
    }

    return (
        <Form className="text-center" onSubmit={handleSubmit(doSubmit)}>

            <Card className="p-4 mb-5 rounded-lg card-shadow">

                <span className="mb-5 font-weight-normal">{t('login.recovery.title')}</span>

                <FormGroup>
                    <Label
                        for="inputEmail"
                        className="sr-only">{t('login.email')}
                    </Label>
                    <Input
                        bsSize="md"
                        type="email"
                        name="email"
                        id="inputEmail"
                        innerRef={register({ required: true })}
                        placeholder={t('login.email_placeholder')}
                        required
                        autoFocus
                    />
                </FormGroup>

                <Button color="primary" className="text-white font-weight-bold" type="submit">
                    {isLoading && <Spinner size="sm" color="light" />}{' '}{t('login.recovery.send')}
                </Button>

            </Card>

            <Button color="default" onClick={handleRemembered} className="text-primary">{t('login.recovery.remember')}</Button>

        </Form>
    )
}

export default function ForgotPassword() {
    
    return (
        <AuthLayout>
          <RecoverForm />
        </AuthLayout>
    )
}
